import React from 'react'
import ForgotPasswordForm from '../../components/Forms/ForgotPasswordForm/ForgotPasswordForm'

const ForgotPasswordPage = () => {
  return (
      <div style={{background: '#fcfcfc'}} className="container-fluid vh-100 d-flex justify-content-center align-items-center">
        <ForgotPasswordForm />
     </div>
  )
}

export default ForgotPasswordPage